// extracted by mini-css-extract-plugin
export var accent = "_72-4";
export var add = "_72-j";
export var addIcon = "_72-k";
export var deleteIcon = "_72-i";
export var disabled = "_72-9";
export var ellipsis = "_72-f";
export var error = "_72-3";
export var form = "_72-5";
export var hideFocus = "_72-2";
export var icon = "_72-7";
export var input = "_72-e";
export var listItem = "_72-h";
export var mediumHeight = "_72-b";
export var noBorder = "_72-8";
export var noRadius = "_72-1";
export var shortHeight = "_72-a";
export var tallHeight = "_72-c";
export var textInput = "_72-0";
export var vertical = "_72-g";
export var veryTallHeight = "_72-d";
export var widget = "_72-6";